/**
 * 六维属性常量定义
 *
 * 说明：
 * - 运行时常量与展示元数据统一在人物模块维护
 * - `types/attributeKeys.ts` 承载类型 Schema
 */

export const ATTRIBUTE_KEYS = ['strength', 'agility', 'intellect', 'vitality', 'charisma', 'luck'] as const;

export type AttributeKey = (typeof ATTRIBUTE_KEYS)[number];

/**
 * 属性技能 ID（当前与属性键保持一致）
 */
export const ATTRIBUTE_SKILL_IDS = [...ATTRIBUTE_KEYS] as const;

export interface AttributeDefinition {
  id: AttributeKey;
  name: string;
  icon: string;
  description: string;
}

const ATTRIBUTE_DEFINITIONS: readonly AttributeDefinition[] = [
  {
    id: 'strength',
    name: '力量',
    icon: '💪',
    description: '影响物理伤害与破坏行为。',
  },
  {
    id: 'agility',
    name: '敏捷',
    icon: '⚡',
    description: '影响速度与精细操作。',
  },
  {
    id: 'vitality',
    name: '体质',
    icon: '❤️',
    description: '影响生命、防护与耐受能力。',
  },
  {
    id: 'intellect',
    name: '智力',
    icon: '🧠',
    description: '影响魔法效能与知识检定。',
  },
  {
    id: 'charisma',
    name: '魅力',
    icon: '🎭',
    description: '影响交涉、说服与社交影响。',
  },
  {
    id: 'luck',
    name: '幸运',
    icon: '🍀',
    description: '影响概率事件与奇迹触发。',
  },
];

export function getAttributeDefinitions(): AttributeDefinition[] {
  return [...ATTRIBUTE_DEFINITIONS];
}
